import { Box } from "@mui/material";
import MenuSitesListDropdown from "../../../../components/MenuSitesListDropdown/MenuSitesListDropdown";
import { useDynamicRoutes } from "../../../../hooks/useDynamicRoutes/useDynamicRoutes";
import MenuItems from "./MenuItems";

export default function Menu(props) {
  const { generatedMenuItems } = useDynamicRoutes();
  return (
    <Box className='menulist'>
      <MenuSitesListDropdown />
      {generatedMenuItems?.map((val, index) => {
        return !val.hidden ? (
          <MenuItems
            key={index}
            Title={val?.id}
            MenuName={val?.menu}
            open={props.open}
            handleMenuclose={props.handleMenuclose}
            handleMenuAction={props.handleMenuAction}
          />
        ) : null;
      })}
    </Box>
  );
}
